import langLayout from './ConnectLayout.lang.json';
import langLogin from './LoginPage/LoginPage.json';

const lang = {
  ...langLogin,
  ...langLayout,
};

const loginUrlBase = window?.env?.WOAD_CONNECT_URL;

export const LOGIN_URL = `${loginUrlBase}&redirect_uri=${window.location.origin}/`;

const links = {
  privacyPolicy: {
    testid: 'privacy-policy',
    text: lang.privacyPolicy,
    url: 'https://www.wiley.com/en-us/privacy',
    target: '_blank',
  },
  termsOfUse: {
    testid: 'terms-of-use',
    text: lang.termsOfUse,
    url: '/woaatnc',
    target: '_self',
  },
  cookies: {
    testid: 'cookies',
    text: lang.cookies,
    url: '/aboutcookies',
    target: '_self',
  },
  dashboard: [
    {
      testid: 'dashboard',
      text: lang.dashboardLink,
      action: 'connectlogin',
    },
  ],
  authorResources: [
    {
      testid: 'resources',
      text: lang.authorResourcesLink,
      url: 'https://authorservices.wiley.com/home.html',
      target: '_blank',
    },
  ],
};

export default links;
